import { create } from 'zustand';

import { UsersPageDataRow } from 'api/users/types';

interface DeleteUserModalState {
  isOpen: boolean;
  userData?: UsersPageDataRow;
  onDeleteUserModalClose: () => void;
  onDeleteUserModalOpen: (userData?: UsersPageDataRow) => void;
}

export const useDeleteUserModalStore = create<DeleteUserModalState>(set => ({
  isOpen: false,
  userData: undefined,
  onDeleteUserModalClose: () => set({ isOpen: false, userData: undefined }),
  onDeleteUserModalOpen: (userData?: UsersPageDataRow) => set({ isOpen: true, userData }),
}));
